import * as React from "react";
import PropTypes from 'prop-types';

const SvgErrorFill = props => {
  if (props.id !== "_svgerrorfill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21.034 7.409l-4.52-4.459a1.798 1.798 0 00-1.284-.55l-6.48.011c-.462 0-.913.187-1.24.514L3.09 7.284a2.357 2.357 0 00-.69 1.674v6.202c0 .514.2.998.562 1.362l4.47 4.485c.38.384.888.594 1.428.594h6.27c.546 0 1.059-.214 1.444-.6l4.316-4.33c.458-.46.71-1.07.71-1.72V8.777c0-.517-.2-1.004-.566-1.37zM10.63 13.37h2.742V6.514H10.63v6.857zM12 17.486a1.371 1.371 0 110-2.743 1.371 1.371 0 010 2.743z" fill="#A32026" /></svg>;
};

SvgErrorFill.displayName = "_svgerrorfill";
SvgErrorFill.propTypes = {
  id: PropTypes.string
};
SvgErrorFill.defaultProps = {
  id: ''
};
export default SvgErrorFill;